// MemberPortalAccess — the §14 owner-portal question on one entity member row of
// the Owner Contact form: "Give <first name> access to the owner portal
// (statements and financials)". Unchecked = no. Offered once the member has an
// email (portal access follows the email); before that, a one-line hint. A box
// already ticked stays visible without an email, so the owner can see and untick
// the stored answer (without an email it counts as no access — it never blocks
// completion), with the same plain hint beneath it.
// PUBLIC, owner-facing — copy in lib/ownerContactMembers.ts (PENDING MILES COPY
// REVIEW). Presentational: the page saves `members[j].portalAccess`, and only
// renders this when the API asks (perOwner[i].askMemberPortalAccess).

import type { OwnerContactMemberContact } from '@/lib/ownerContactClient';
import {
  PORTAL_ACCESS_EMAIL_HINT,
  portalAccessLabel,
  portalAccessNeedsEmail,
  showPortalAccessCheckbox,
} from '@/lib/ownerContactMembers';

export function MemberPortalAccess({
  member,
  onChange,
}: {
  member: OwnerContactMemberContact;
  onChange: (portalAccess: boolean) => void;
}): React.JSX.Element {
  if (!showPortalAccessCheckbox(member)) {
    return (
      <span className="helper" style={{ color: 'var(--fg-muted)' }} data-testid="portal-access-hint">
        {PORTAL_ACCESS_EMAIL_HINT}
      </span>
    );
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
        <input
          type="checkbox"
          checked={member.portalAccess === true}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="helper" style={{ color: 'var(--fg-muted)' }}>
          {portalAccessLabel(member)}
        </span>
      </label>
      {portalAccessNeedsEmail(member) && (
        <span className="helper" style={{ color: 'var(--fg-muted)' }} data-testid="portal-access-needs-email">
          {PORTAL_ACCESS_EMAIL_HINT}
        </span>
      )}
    </div>
  );
}
